// extracted by mini-css-extract-plugin
module.exports = {"option-container":"assignee-select__option-container___1zUr9","option-title":"assignee-select__option-title___28rcm"};